import { MobileSearchWidget } from '@/components/search-widget/MobileSearchWidget';
import { RegularSearchWidget } from '@/components/search-widget/RegularSearchWidget';
import {
  salesPointConfigurationSelector,
  tenantSelector,
} from '@/features/configuration/configurationSelector';
import {
  outboundOrInboundJourneysLoadingSelector,
  purchaseFlowBookingCreationLoadingSelector,
} from '@/features/loading/loadingSelectors';
import { purchaseFlowBookingIdSelector } from '@/features/purchase/purchaseSelectors';
import { useSearchWidget } from '@/hooks/useSearchWidget';
import { useSelector } from '@/store/utils';
import { breakpoints } from '@/utils/breakpoints';
import { getTenantBrand } from '@/utils/color';
import { getTenantConfiguration } from '@/utils/tenant';
import { parseUrlSearchParams } from '@/utils/urlSearchParams';
import { Divider } from '@fleet/webshop-ui';
import { SearchWidget } from '@turnit-ride-ui/webshop-search-widget';
import { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useLocation } from 'react-router-dom';

export const SearchWidgetWrapper = () => {
  const { pathname, search } = useLocation();
  const tenant = useSelector(tenantSelector);
  const configuration = getTenantConfiguration(tenant.value);
  const { brandColors } = getTenantBrand(tenant);
  const { handleSubmit, currentSearchFormValues } = useSearchWidget();
  const salesPointConfiguration = useSelector(salesPointConfigurationSelector);
  const purchaseBookingId = useSelector(purchaseFlowBookingIdSelector);
  const outboundOrInboundJourneysLoading = useSelector(
    outboundOrInboundJourneysLoadingSelector
  );
  const bookingLoading = useSelector(
    purchaseFlowBookingCreationLoadingSelector
  );
  const isLaptopOrBigger = useMediaQuery({
    minWidth: breakpoints.laptop,
  });
  const [isAutoSubmitted, setIsAutoSubmitted] = useState(false);
  const searchParams = new URLSearchParams(search);
  const defaultProductType = searchParams.get('productType') as
    | 'ticket'
    | 'travelPass'
    | null;

  useEffect(() => {
    if (salesPointConfiguration?.currencies?.length && !purchaseBookingId) {
      const {
        productType,
        origin,
        destination,
        departureDate,
        returnDate,
        passengers,
        promoCodes,
      } = parseUrlSearchParams(salesPointConfiguration.passengerTypes);

      if (
        origin?.value &&
        destination?.value &&
        departureDate &&
        passengers &&
        productType &&
        !isAutoSubmitted
      ) {
        handleSubmit({
          productType,
          origin,
          destination,
          departureDate,
          returnDate,
          passengers,
          promoCodes,
        });
      }

      setIsAutoSubmitted(true);
    }
  }, [
    handleSubmit,
    isAutoSubmitted,
    purchaseBookingId,
    salesPointConfiguration?.currencies?.length,
    salesPointConfiguration?.passengerTypes,
  ]);

  const Component = isLaptopOrBigger ? RegularSearchWidget : MobileSearchWidget;

  return (
    <div className="sticky top-0 z-50 bg-background">
      <Component>
        <SearchWidget
          baseUrl={import.meta.env.VITE_APP_PROXY_TARGET}
          onSubmit={handleSubmit}
          height="small"
          shouldDisableSubmitButton={
            outboundOrInboundJourneysLoading || bookingLoading
          }
          brandColors={brandColors}
          backgroundTheme="light"
          stopsSearchingStrategy={configuration?.stopsSearchingStrategy}
          formValues={currentSearchFormValues}
          submitOnPromoCodeChange={pathname !== '/purchase'}
          defaultProductType={defaultProductType ?? undefined}
        />
      </Component>
      <Divider variant="medium" />
    </div>
  );
};
